import { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { stopRunningProg } from "../services/rashTradeServices";

class ProgramsStatus extends Component {
    state = {};
    render() {
        const progs = [
            {
                progName: "App ",
                progId: "APP"
            },
            {
                progName: "Candles ",
                progId: "CANDLE"
            }
        ];
        const isDarkMode = this.props.isDarkMode;
        return (
            <div className="w-full min-h-screen flex justify-center items-center ">
                <div
                    className={`w-11/12 h-2/3 ${
                        isDarkMode ? "bg-primaryLight" : "bg-primaryLight primaryBoxShadow"
                    } rounded-lg flex items-center flex-col md:w-1/2 lg:w-1/4`}>
                    <div
                        className={`w-full flex justify-center items-center ${
                            isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                        }  rounded-t-lg min-h-12`}>
                        Running progs to stop
                    </div>
                    {progs.map((prog, index) => {
                        const { progName, progId } = prog;
                        return (
                            <div
                                key={index}
                                className={`${
                                    isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                                } w-11/12 rounded-lg mt-4 py-4 px-2 flex`}>
                                <div className="flex-1 flex justify-start pl-2 items-center">
                                    {progName}
                                </div>
                                <img
                                    src="/icons/terminals.png"
                                    className="max-w-8 flex-1 cursor-pointer"
                                    alt="terminal"
                                    onClick={() => stopRunningProg(progId)}
                                />
                            </div>
                        );
                    })}
                </div>
                <ToastContainer />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const isDarkMode = state.persistedReducer.isDarkMode;
    return {
        isDarkMode
    };
};

export default connect(mapStateToProps, null)(ProgramsStatus);
